<template>
  <div class="col-sm-12 col-md-12 col-lg-12">
    <OrderCard :orders="orders" :noOrders="noOrders" />
  </div>
</template>

<script>
import OrderCard from "../../components/adminUi/OrderCard";
export default {
  components: { OrderCard },
  data() {
    return {
      noOrders: false,
    };
  },
  computed: {
    status() {
      return this.$store.getters.getStatus;
    },
    orders() {
      if (this.status.name != "user" || this.status.stat !== true) {
        this.$router.push({ path: "/" });
      } else {
        var orders = this.$store.getters.getOrders;
        var status = this.$store.getters.getStatus;
        orders = orders.filter((order) => order.user.id == status.id);
        console.log("User Cart Route: ", orders.length);
        if (orders.length > 0) {
          return orders;
        } else {
          this.noOrders = true;
        }
      }
    },
  },
  mounted() {
    this.closeList();
  },
  methods: {
    closeList() {
      this.$store.dispatch("closeCart", false);
    },
  },
};
</script>

<style></style>
